import CouponsDataTable from "@pages/main/coupons/sub_components/coupons_data_table"

export default function CouponsPage() {
  return (
    <>
      <CouponsDataTable />
    </>
  )
}
